/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DentalSurface from './dental-surface';
import DentalSurfaceDetail from './dental-surface-detail';
import DentalSurfaceUpdate from './dental-surface-update';
import DentalSurfaceDeleteDialog from './dental-surface-delete-dialog';

const DentalSurfaceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DentalSurface />} />
    <Route path="new" element={<DentalSurfaceUpdate />} />
    <Route path=":id">
      <Route index element={<DentalSurfaceDetail />} />
      <Route path="edit" element={<DentalSurfaceUpdate />} />
      <Route path="delete" element={<DentalSurfaceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DentalSurfaceRoutes;
